import request from "../../../core/wrappers/axios-wrapper";
import { ApiURL } from "../../../types/constants/apiUrls/api-urls";
import { RequestType } from "../../../types/enums/request-enums";
 //#region comment metod

 const GetMusteriİade = (data: any): Promise<any>  =>
 request({
   url: ApiURL.Command.GetMusteriİade,
   method: RequestType.POST,
   data, 
 });
 const GetCustomerDecision = (data: any): Promise<any>  =>
 request({
   url: ApiURL.Command.GetCustomerDecision,
   method: RequestType.POST,
   data, 
 });  
 const StoreReturnCommand = {
  GetMusteriİade ,
  GetCustomerDecision
  }
  
  export default StoreReturnCommand;